import React, {Component} from 'react';
import Button from "@material-ui/core/Button/Button";
import Link from "react-router-dom/Link";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_institutions_details.json';

class InstitutionsDetailsPlaceholder extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    render() {
        return (
            <article className="institutions placeholder">
                <header>
                    <div className="row">
                        <div className="col col-9">
                            <Button size="medium" className="btnBack" component={props => <Link to={this.props.translate('routes.institutions')} {...props}/>}>
                                <KeyboardBackspaceIcon className="btnIcon" />
                                <Translate id="institutions_details.button_back" />
                            </Button>

                            <h1><span className="placeholder-line"></span></h1>
                        </div>
                    </div>
                </header>
                <div className="row row-content">
                    <div className="col col-12">
                        <div className="content-inner">
                            <span className="placeholder-line"></span>
                            <span className="placeholder-line"></span>
                            <span className="placeholder-line"></span>
                            <span className="placeholder-line"></span>
                            <span className="placeholder-line"></span>
                            <span className="placeholder-line"></span>
                            <span className="placeholder-line"></span>
                            <span className="placeholder-line"></span>
                        </div>
                    </div>
                </div>
            </article>
        );
    }
}

export default withLocalize(InstitutionsDetailsPlaceholder);



// WEBPACK FOOTER //
// ./src/features/Institutions/components/Details/InstitutionsDetailsPlaceholder.js